<h1 mat-dialog-title i18n="School Details|School Details modal title@@school-details-modal-title">School Details</h1>
<div mat-dialog-content #dialogContent class="school-details">
  <school-details *ngIf="school"
                  [school]="school"
                  [types]="schoolTypes"
                  [fullDetails]="true"></school-details>
</div>
<div mat-dialog-actions>
  <app-button label="Close"
              i18n-label="General|Close action label@@general-close-action-label"
              [disabled]="inProgress"
              (clicked)="proceed()"></app-button>
</div>
